// extracted by mini-css-extract-plugin
module.exports = {"text":"DesignerCard_text__QtL9c"};